import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
// import { GrabExpressPath } from "./url";
import MallOrdersListComponent from "./views/MallOrdersList";

const MallOrdersList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));
  return <MallOrdersListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Grab Express",
          description: "grab express section"
        })}
      />
      <Routes>
        <Route path="" element={<MallOrdersList />} />
      </Routes>
    </>
  );
};

export default Component;
